import {
  Backdrop as MUIBackdrop,
  BackdropProps as MUIBackdropProps,
  CircularProgress,
  Box,
  SxProps,
  Theme,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useMemo } from 'react';

export type BackdropProps = MUIBackdropProps & {
  fullscreen?: boolean;
};

export function Backdrop(props: BackdropProps) {
  const { fullscreen, children, ...restProps } = props;

  const sx = useMemo(() => {
    return {
      position: 'absolute',
      zIndex: (theme) => theme.zIndex.drawer + 1,
      backgroundColor: (theme) => alpha(theme.palette.common.black, 0.1),
      ...restProps?.sx,
    } as SxProps<Theme>;
  }, [restProps?.sx]);

  if (fullscreen) {
    return (
      <>
        <MUIBackdrop {...restProps} sx={sx}>
          <CircularProgress />
        </MUIBackdrop>
        {children}
      </>
    );
  }

  return (
    <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
      {children}
      <MUIBackdrop {...restProps} sx={sx}>
        <CircularProgress />
      </MUIBackdrop>
    </Box>
  );
}
